import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    header: {
      padding: '40px 0 100px 0',
    },
    body: {
      borderTopRightRadius: 50,
      borderTopLeftRadius: 50,
      minHeight: '50vh',
      background: '#F7F7FB',
      paddingBottom: 50,
    },
    containerProfile: {
      display: 'flex',
      width: '80%',
      alignItems: 'center',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    breadcrumbs: {
      paddingLeft: '50px',
      color: 'white',
      fontSize: 14,
      fontFamily: 'Poppins',
      fontWeight: 500,
      wordWrap: 'break-word',
      textTransform: 'none',
      display: 'flex',
      alignItems: 'center',
    },

    title: {
      fontFamily: 'ITC Avant Garde Gothic Std Bold',
      fontSize: 30,
      textTransform: 'none',
      color: 'white',
    },
    matchingTitle: {
      fontFamily: 'Open Sans',
      fontWeight: 700,
      fontSize: 26,
      lineHeight: '100%',
      textTransform: 'none',
      marginBottom: 10,
    },
    address: {
      fontFamily: 'Open Sans',
      color: 'white',
      fontWeight: 500,
      fontSize: 12,
      lineHeight: '150%',
      marginLeft: 5,
    },
    containerSection: {
      width: '80%',
      display: 'block',
      marginLeft: 'auto',
      marginRight: 'auto',
      marginTop: 20,
    },
    candidatesBtn: {
      textTransform: 'none',
      fontFamily: 'Poppins',
      fontSize: 14,
      paddingTop: 7,
      fontWeight: 500,
      width: 'fit-content',
      color: 'white',
      borderColor: 'white',
    },
    flex: {
      display: 'flex',
      alignItems: 'center',
      color: 'white',
    },
    floatRight: {
      justifyContent: 'center',
      float: 'right',
    },
    candidatesChips: {
      marginLeft: 10,
      fontSize: 14,
      paddingTop: 5,
      fontWeight: 500,
      width: 'fit-content',
      color: 'white',
      borderColor: 'white',
    },
    titleTable: {
      color: '#000A8C',
      fontFamily: 'Poppins',
      fontSize: 16,
      fontStyle: 'normal',
      fontWeight: 700,
    },
    titleSubTable: {
      fontFamily: 'Open Sans',
      fontWeight: 700,
      fontSize: 14,
      color: '#151528',
      lineHeight: '100%',
    },
    section: {
      margin: 10,
      width: '100%',
    },
    toolsTitle: {
      fontFamily: 'Open Sans',
      fontWeight: 500,
      fontStyle: 'italic',
      fontSize: 14,
      color: '#151528',
    },
    toolsItem: {
      fontFamily: 'Open Sans',
      fontWeight: 500,
      fontStyle: 'italic',
      fontSize: 14,
      color: '#000A8C',
    },
    languageChip: {
      backgroundColor: '#BC72A7',
      color: 'white',
      borderRadius: 5,
      marginRight: 10,
    },
    ratingBorder: {
      border: '1px dashed #A9AAB8',
    },
    ratingValue: {
      color: '#151528',
      fontFamily: 'Open Sans',
      fontWeight: 700,
      fontSize: 16,
    },
    ratingTitle: {
      color: '#151528',
      fontFamily: 'Open Sans',
      fontWeight: 500,
      fontSize: 14,
      marginLeft: 10,
      marginBottom: 2,
    },
    ratingStars: {
      display: 'flex',
      justifyContent: 'center',
      marginLeft: 10,
      marginRight: 10,
    },
    titleItalic: {
      fontStyle: 'italic',
      fontSize: 20,
      color: 'white',
      marginTop: 40,
      marginBottom: 15,
    },
  })
);
